export const getSectionProps = props => {
  if (props.section) {
    return props.section.fields
  }

  return props
}
